/**
 * Application scripts
 * Usage: Add imports here for third party scripts, such as GSAP
 *
 * Example: import { gsap } from gsap;
 */
import * as PIXI from "pixi.js";
import * as viewport from './app/viewport'
import * as gallery from './app/gallery'


if (document.querySelector("body.brilliant-things")) {

    const config = window.brilliantThingsConfig || null
    let renderer;

    function createRenderer() {
        renderer = new PIXI.Renderer({
            backgroundAlpha: 0,
            width: window.innerWidth,
            height: window.innerHeight,
            resolution: window.devicePixelRatio,
            antialias: true,
        })
        document.body.appendChild(renderer.view)
        renderer.view.style.position = 'fixed'
        renderer.view.style.width = '100vw'
        renderer.view.style.height = '100vh'
        renderer.view.style.top = 0
        renderer.view.style.left = 0
        renderer.view.style.zIndex = 1
        renderer.view.style.touchAction = 'none'
    }

    function start() {
        createRenderer()
        viewport.create(renderer)

        if (config) {
            gallery.create(viewport.get(), config, renderer)
        }

        window.onresize = () => {
            renderer.resize(window.innerWidth, window.innerHeight)
            viewport.get().resize(window.innerWidth, window.innerHeight)
        }
        update()
    }

    function update() {
        const vp = viewport.get()
        if (vp.dirty || gallery.needsRender()) {
            renderer.render(vp)
            vp.dirty = false
        }
        requestAnimationFrame(() => update())
    }

    document.querySelectorAll('[data-trigger="render"]').forEach(el => {
        el.addEventListener('click', () => document.fonts.ready.then(start), { once: true })
    })

}
